import React, { useState, useEffect } from "react";
import { withSidebar } from "../hoc/withSidebar";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import ResponsiveDataGrid from "../custom/containers/ResponsiveDataGrid";
import { useTranslation } from "react-i18next";
import { viewRelatedBillerDocuments } from "../../constants/AvailableDocumentsConstant";

import AvailableDocuments from "./AvailableDocuments";

import { relatedBillerActions } from "../../actions/relatedBiller.action";
import { useDispatch, useSelector } from "react-redux";
import { ResponsiveBox, Typography, HStack } from "../primitives";

function DownloadDocuments(props) {
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const [childBillerResults, setChildBillerResults] = useState(null);

  const billerProfileValueRes = useSelector(
    (state) => state.billerProfileReducer
  );

  const billerProfileValue =
    billerProfileValueRes?.billerProfileAssociatedData ||
    billerProfileValueRes?.billerProfileData?.data;

  const selectedFi = useSelector((state) => state.fiReducer?.selectedFi);

  const loginUser = useSelector((state) => state.loginUserReducer?.user);

  const fiNumber = selectedFi || loginUser.fiNumber;

  const parentBillerResults = loginUser?.searchBillerFilesDto;

  const childBillerListResponse = useSelector(
    (state) => state.relatedBillerReducer?.childBillerList
  );

  useEffect(() => {
    dispatch(
      relatedBillerActions.getAllChildBiller(
        {
          billerFiNumber:
            loginUser?.billerNonVolatileDto?.biller_fi_number ||
            billerProfileValue?.billerFiNumber,
          fiNumber,
        },
        { ...props }
      )
    );
  }, []);

  useEffect(() => {
    if (childBillerListResponse && childBillerListResponse.length) {
      const updatedChildBillerListResponse = childBillerListResponse.map(
        (data, idx) => ({...data, id: idx })
      );
      setChildBillerResults(updatedChildBillerListResponse);
    }
  }, [childBillerListResponse]);

  const getParentChildRelatedBiller = () => {
    return (
      <ResponsiveBox role="main" sx={{ ml: 3, minHeight: !childBillerResults?.length ? "60vh" : "" }}>
        <ResponsiveBox mt={4}>
          <Typography variant="h1">
            {t("erps.downloaddocuments.page.title", "Download documents")}
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox className="manageUsers__wrap__box">
          <Typography variant="body1">
            {t("erps.availabledocuments.page.description", "Download reports and invoices")}
          </Typography>
        </ResponsiveBox>
        <ResponsiveBox mt={4}>
          <Typography variant="h2">{"Parent biller"}</Typography>
        </ResponsiveBox>
        <HStack spacing={18} mt={4}>
          <ResponsiveBox>
            <Typography variant="inherit">
              {t("erps.availabledocuments.label.billerId")}
              <Typography variant="body2">
                {fiNumber == 99 && props?.stateId
                  ? props?.stateId
                  : parentBillerResults?.fi_biller_with_biller_id ||
                    `${
                      billerProfileValue?.billerNonVolatileDto
                        ?.biller_fi_number || billerProfileValue?.billerFiNumber
                    }-${billerProfileValue?.billerId}`}
              </Typography>
            </Typography>
          </ResponsiveBox>
          <ResponsiveBox>
            <Typography variant="inherit">
              {t("erps.availabledocuments.label.description")}
              <Typography variant="body2">
                {parentBillerResults?.biller_name || billerProfileValue?.billerName}
              </Typography>
            </Typography>
          </ResponsiveBox>
          <ResponsiveBox>
            {props?.pageName === "biller-profile" ? (
              <ERPSBaseLink
                onClick={() =>
                  props?.handleOpenViewDocument({
                    billerId: parentBillerResults?.biller_id || billerProfileValue?.billerId,
                    billerType: "parent",
                  })
                }
                className="link__blue"
                label={t("erps.availabledocuments.label.viewdocuments")}
              />
            ) : (
              <ERPSBaseLink
                to={{
                  pathname: `/downloads-documents/view-documents`,
                  state: {
                    billerId: parentBillerResults?.biller_id || billerProfileValue?.billerId,
                    billerType: "parent",
                    searchedBillerId: parentBillerResults?.biller_id || billerProfileValue?.billerId,
                  },
                }}
                className="link__blue"
                label={t("erps.availabledocuments.label.viewdocuments")}
              />
            )}
          </ResponsiveBox>
        </HStack>
        {childBillerResults?.length ? (
          <>
            <ResponsiveBox mt={4}>
              <Typography variant="h2">
                {t("erps.availabledocuments.label.relatedbiller.title")}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox mt={4}>
              <Typography variant="body1">
                {t("erps.availabledocuments.label.relatedbiller.description")}{" "}
              </Typography>
            </ResponsiveBox>

            <ResponsiveBox marginTop={1} marginBottom={1.5} sx={{ display: "flex" }}>
              <Typography variant="body1">
                {childBillerResults?.length}{" "}
                {t("erps.availabledocuments.label.childebillers")}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox className="manageUsers_table_visible">
              <ResponsiveDataGrid
                data={{
                  rows: childBillerResults,
                  count: childBillerResults?.length,
                  columns: viewRelatedBillerDocuments(props),
                }}
                dataGridWidth="dataGrid__box__container_downloadDocuments"
                initialLoading={childBillerResults?.length ? false : true}
                tableLableText={t(
                  "erps.availabledocuments.label.childebillers"
                )}
              />
            </ResponsiveBox>
          </>
        ) : null}
      </ResponsiveBox>
    );
  };

  const getAvailableDocument = () => {
    return <AvailableDocuments {...props} pageName="download-document" />;
  };

  return (
    <div>
      {childBillerResults
        ? getParentChildRelatedBiller()
        : getAvailableDocument()}
    </div>
  );
}

export default withSidebar(DownloadDocuments);
